const prod = window.location.hostname === 'esign-proteantech.in';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './template.styles.css';
import App from './App';
import './Services/i18n';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import TagManager from 'react-gtm-module';
import ErrorBoundary from './Components/Pages/ErrorBoundary';

if (prod) {
  const tagManagerArgs = {
    gtmId: 'GTM-NJFCT84G'
  };

  TagManager.initialize(tagManagerArgs);
}

i18next.init({
  interpolation: { escapeValue: false }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => (
  <I18nextProvider i18n={i18next}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </I18nextProvider>
);

root.render(renderApp());
